

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormChoiceDto } from '@/api';
import Placeholder from '@/views/account/Placeholder.vue';

@Component({
  components: {Placeholder},
})
export default class FormBlock extends Vue {
  @Prop({required: true, default: ''})
  private value!: string;

  @Prop({required: true})
  private formChoiceDto!: FormChoiceDto;

  private values: string[] = [];

  public onChange(event: any) {
    this.$emit('input', event.target.value);
  }

  public onCheckChange() {
    const selectedValues = this.values.reduce((previousValue, currentValue) => previousValue + ', ' + currentValue, '');
    this.$emit('input', selectedValues.replace(',', ''));
  }

  public radioChange(option: string) {
    this.$emit('input', option);
  }

  get options(): string[] {
    return this.formChoiceDto.choices || [];
  }

  get label(): string {
    return this.formChoiceDto.label;
  }

  get fieldRequired(): boolean {
    return this.formChoiceDto.required;
  }

  get isSelect(): boolean {
    return this.formChoiceDto.type === 'select';
  }

  get isRadio(): boolean {
    return this.formChoiceDto.type === 'radio';
  }

  get isCheck(): boolean {
    return this.formChoiceDto.type === 'check';
  }
}

